import { EMPTY_STRING } from '../../../constants/common'
import { formatChatroomStartedDate } from '../Chatroom.utils'

export function getChatroomStartedLabel({ createdAt, t, timeZone }) {
  const formatted = formatChatroomStartedDate({ date: createdAt, timeZone })

  if (!formatted) {
    return EMPTY_STRING
  }

  return `${t('Chatroom.ChatStartedKey')} – ${formatted}`
}
